"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languagesObj = void 0;
/**
 * We have this languagesObj to ensure we don't forget to add a language.
 * (Typescript will catch missing languages because of the Record<TLanguage, true> type. (An object that must
 * have ALL TLanguages as its keys))
 */
exports.languagesObj = {
    'en': true,
    'en-AU': true,
    'es': true,
    'it': true,
};
//# sourceMappingURL=languagesObj.js.map